import { BellIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Text } from "@chakra-ui/react";
import { CustomModal } from "components/custom-modal";
import { useNotificationContext } from "contexts/notification-context";
import { useModalControls } from "hooks/use-modal-controls";
import { useEffect, useState } from "react";

function formatDate(isoString: string) {
  try {
    return new Date(isoString).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
      hour: "2-digit",
      minute: "2-digit"
    });
  } catch {
    return isoString;
  }
}

export function ModalAlerts() {
  const { alerts, markAsRead, isLoading } = useNotificationContext();
  const { isOpen, onClose, onOpen } = useModalControls("open-alerts-modal");
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    console.log("modal, alerts carregadas: ", JSON.stringify(alerts));
    if (alerts.length > 0) {
      setCurrentIndex(0);
      onOpen();
    }
  }, [alerts.length]);

  useEffect(() => {
    if (currentIndex >= alerts.length && alerts.length > 0) {
      setCurrentIndex(alerts.length - 1);
    }
  }, [alerts.length, currentIndex]);

  const currentAlert = alerts[currentIndex];
  const total = alerts.length;

  async function handleMarkAsRead() {
    try {
      if (currentAlert) {
      await markAsRead(currentAlert.id);
    }
    } catch (e) {
      console.error("Erro ao marcar alerta como lido", e);
    } finally {
      onClose();
    }
  }

  return (
    <CustomModal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      modalTitle={
        <Flex alignItems="center" gap="8px">
          <Box transform="translateY(-1px)">
            <BellIcon color="orange.500" w="20px" h="20px" />
          </Box>
          Alertas
          {total > 0 && (
            <Text as="span" fontSize="13px" fontWeight="400" color="gray.500">
              ({currentIndex + 1} de {total})
            </Text>
          )}
        </Flex>
      }
      modalFooter={
        total === 0 ? (
          <Button variant="ghost" onClick={onClose}>
            Fechar
          </Button>
        ) : (
          <Flex justify="space-between" w="full" align="center">
            <Flex gap="8px">
              <Button
                size="sm"
                variant="outline"
                onClick={() => setCurrentIndex((i) => i - 1)}
                isDisabled={currentIndex === 0}
              >
                ← Anterior
              </Button>
              <Button
                size="sm"
                variant="outline"
                onClick={() => setCurrentIndex((i) => i + 1)}
                isDisabled={currentIndex === total - 1}
              >
                Próximo →
              </Button>
            </Flex>
            <Button
              colorScheme="blue"
              size="sm"
              onClick={handleMarkAsRead}
              isLoading={isLoading}
              loadingText="Carregando..."
            >
              Marcar como lido
            </Button>
          </Flex>
        )
      }
    >
      {total === 0 ? (
        <Flex
          direction="column"
          alignItems="center"
          justifyContent="center"
          py="32px"
          gap="8px"
          color="gray.400"
        >
          <BellIcon w="24px" h="24px" />
          <Text fontSize="13px">Nenhum alerta pendente</Text>
        </Flex>
      ) : (
        <Flex direction="column" gap="8px" py="8px">
          {currentAlert.payload.titulo && (
            <Text fontSize="16px" fontWeight="600" color="gray.800">
              {currentAlert.payload.titulo}
            </Text>
          )}
          <Text fontSize="14px" color="gray.600" lineHeight="1.6">
            {currentAlert.payload.mensagem}
          </Text>
          <Text fontSize="11px" color="gray.400" mt="4px">
            {formatDate(currentAlert.sentAt)}
          </Text>
        </Flex>
      )}
    </CustomModal>
  );
}

export { useModalControls as useAlertsModal };